import { ReactComponent as SaveAsIcon } from './save_as.svg';

export default SaveAsIcon;
